import { useRequest } from 'ahooks';
import React, { useEffect, useState } from 'react';
import { notify } from '../../../api/api';
import { ProjectStatus, TheaterType, UserRole } from '../../../enums';
import { VerifyOwnerAlert } from '../../alerts';
import { VerifyOwnerNotificationModal } from '../../modals';

export interface ProjectOwnershipWrapperProps {
  projectId: number;
  defaultTheater: TheaterType;
  userRole: UserRole | string;
  ownershipVerified: boolean;
  ownerId: number;
  projectStatus: ProjectStatus | string;
  onSuccess: () => void;
}

export const ProjectOwnershipWrapper = (props: ProjectOwnershipWrapperProps) => {
  const [showNotifyModal, setShowNotifyModal] = useState<boolean>(false);
  const [showNotifyAlert, setShowNotifyAlert] = useState<boolean>(false);

  const isValidProject =
    (props.userRole === UserRole.DellAdminUser || props.userRole === UserRole.DellUser) &&
    !props.ownershipVerified &&
    props.ownerId === 1 &&
    (props.projectStatus === ProjectStatus.Completed ||
      props.projectStatus === ProjectStatus.CompletedAndEmailSent);

  const notifyRequest = useRequest(notify, {
    manual: true,
    debounceWait: 500,
  });

  useEffect(() => {
    if (isValidProject) {
      notifyRequest
        .runAsync(props.projectId)
        .then((state: boolean) => {
          setShowNotifyAlert(true);
          setShowNotifyModal(state);
        })
        .catch(() => {
          setShowNotifyAlert(true);
          setShowNotifyModal(false);
        });
    }
  }, [
    props.userRole,
    props.ownershipVerified,
    props.ownerId,
    props.projectId,
    props.projectStatus,
    isValidProject,
  ]);

  if (isValidProject)
    return (
      <>
        {showNotifyAlert ? (
          <VerifyOwnerAlert
            projectId={props.projectId}
            defaultTheater={props.defaultTheater}
            onSuccess={props.onSuccess}
          />
        ) : (
          <></>
        )}
        {showNotifyModal ? (
          <VerifyOwnerNotificationModal
            projectId={props.projectId}
            defaultTheater={props.defaultTheater}
            onSuccess={props.onSuccess}
          />
        ) : (
          <></>
        )}
      </>
    );
  return <></>;
};
